"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreCommonsPluginModule = exports.CoreBasePluginModule = exports.MODULE_NAME_CORE_PLUGIN = void 0;
const helpers_1 = require("../../core/helpers");
const module_1 = require("../module");
const types_1 = require("./types");
const messages_1 = require("./messages");
exports.MODULE_NAME_CORE_PLUGIN = 'CoreBasePluginModule';
__exportStar(require("./messages"), exports);
__exportStar(require("./types"), exports);
class CoreBasePluginModule extends module_1.CoreBaseModule {
    /**
     * It's needed to implement the constructor to merge options and more, can so simple like this:
     * `
     *   constructor() {
     *     super({});
     *   }
     * `
     * @param defaultOptions
     * @param options
     * @protected
     */
    constructor(defaultOptions, ...options) {
        super(defaultOptions, ...options);
        this.validatePlugins();
    }
    /**
     * This method resolve the plugins (in order) and run the method send by enum (handler as string)
     *
     * @param fnName enumerator (method name)
     * @param data
     * @protected
     */
    executePluginMethod(fnName, data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.pluginLoaded()) {
                return Promise.resolve(data);
            }
            this.validatePlugins();
            let pluginsCount = 0;
            const infosToShow = [];
            const result = yield ((_a = this.getOptions().plugins) === null || _a === void 0 ? void 0 : _a.reduce((previousPromise, plugin) => __awaiter(this, void 0, void 0, function* () {
                const previousValue = yield previousPromise;
                // @ts-expect-error this is "reflection", with ENUMs does not support by ts
                if (plugin[fnName]) {
                    const pluginName = this.resolvePluginName(plugin);
                    try {
                        infosToShow.push(`[${this.constructor.name}.${pluginName}.${fnName}][${++pluginsCount}]`);
                        if (plugin === null || plugin === void 0 ? void 0 : plugin.debug) {
                            infosToShow.push('Input value: ' + JSON.stringify(previousValue, null, ' '));
                        }
                        // @ts-expect-error this is "reflection", with ENUMs does not support by ts
                        const nextValue = yield plugin[fnName](previousValue);
                        if (plugin === null || plugin === void 0 ? void 0 : plugin.debug) {
                            infosToShow.push('Output value: ' + JSON.stringify(nextValue, null, ' '));
                        }
                        return nextValue;
                    }
                    catch (e) {
                        // add more information to track the error
                        const err = e;
                        throw Error(`Plugin "${pluginName}:${fnName}" of "${this.constructor.name}": ${err.stack ? err.stack : err}`);
                    }
                }
                return previousValue;
            }), Promise.resolve(data)));
            if (infosToShow.length > 0) {
                helpers_1.Log.info(`[${this.constructor.name}.{plugins}.${fnName}][${pluginsCount} found]`);
                infosToShow.forEach(info => helpers_1.Log.info(info));
            }
            return Promise.resolve(result);
        });
    }
    validatePlugins() {
        var _a;
        if (this.pluginLoaded()) {
            (_a = this.getOptions().plugins) === null || _a === void 0 ? void 0 : _a.forEach(plugin => {
                const pluginName = this.resolvePluginName(plugin);
                if (pluginName === 'Object') {
                    // function without name sent as plugin
                    helpers_1.Log.error(messages_1.CorePluginMessages.CORE_MODULE_PLUGIN_WITHOUT_NAME);
                    throw Error(messages_1.CorePluginMessages.CORE_MODULE_PLUGIN_WITHOUT_NAME);
                }
            });
        }
    }
    resolvePluginName(plugin) {
        return plugin.name ? plugin.name : plugin.constructor.name;
    }
    pluginLoaded() {
        const options = this.getOptions();
        return options && options.plugins && options.plugins.length > 0;
    }
}
exports.CoreBasePluginModule = CoreBasePluginModule;
class CoreCommonsPluginModule extends CoreBasePluginModule {
    /**
     * `executePluginPre` ('pre') you can use this prefix as PRE-process something
     *
     * method to use on your main class, this is a kind of hook,
     * you decide where and when put this invoke, and the plugin has the method that will be executed
     *
     * @param data
     * @protected
     */
    executePluginPre(data) {
        return this.executePluginMethod(types_1.CoreCommonPluginMethods.Pre, data);
    }
    /**
     * `executePlugin` you can use this to execute something in a pipeline
     *
     * method to use on your main class, this is a kind of hook,
     * you decide where and when put this invoke, and the plugin has the method that will be executed
     *
     * @param data
     * @protected
     */
    executePlugin(data) {
        return this.executePluginMethod(types_1.CoreCommonPluginMethods.Execute, data);
    }
    /**
     * `executePluginPost` ('pre') you can use this prefix as POST-process something
     *
     * method to use on your main class, this is a kind of hook,
     * you decide where and when put this invoke, and the plugin has the method that will be executed
     *
     * @param data
     * @protected
     */
    executePluginPost(data) {
        return this.executePluginMethod(types_1.CoreCommonPluginMethods.Post, data);
    }
}
exports.CoreCommonsPluginModule = CoreCommonsPluginModule;
//# sourceMappingURL=index.js.map